function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LayerListToolingService = /*#__PURE__*/function () {
  function LayerListToolingService() {
    _classCallCheck(this, LayerListToolingService);
    this.tools = {};
    Oskari.makeObservable(this);
  }

  /**
   * @method getName
   * @return {String} service name
   */
  return _createClass(LayerListToolingService, [{
    key: "getName",
    value: function getName() {
      return 'LayerListToolingService';
    }

    /**
     * @method getQName
     * @return {String} fully qualified name for service
     */
  }, {
    key: "getQName",
    value: function getQName() {
      return 'Oskari.mapframework.service.LayerListToolingService';
    }

    /**
     * @method addTool
     * To add a tool to the service.
     *
     * @param {Oskari.mapframework.domain.Tool} tool required
     */
  }, {
    key: "addTool",
    value: function addTool(tool) {
      if (!tool || !tool.getName() || !tool.getCallback()) {
        return;
      }
      this.tools[tool.getName()] = tool;
      this.trigger('add', {
        tool: tool
      });
    }
  }, {
    key: "getTools",
    value: function getTools() {
      return this.tools;
    }
  }]);
}();
LayerListToolingService.TYPE_CREATE = 'create';
Oskari.clazz.defineES('Oskari.mapframework.service.LayerListToolingService', LayerListToolingService, {
  'protocol': ['Oskari.mapframework.service.Service']
});